import { Card, Grid } from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/es'; // importa y registra el locale
import { useContext, useEffect } from 'react';
import { InternacionesTramitesContext } from '../context';
import { GraficoBar } from './GraficoBar';
import { useInternacionesIniciadoAutorizadoBarraApilada } from '../hooks';
dayjs.locale('es'); // activa el idioma español

export const IniciadoAutorizadoMensualBarraApilada = () => {
  const { mensualList, mensualDate } = useContext(InternacionesTramitesContext);
  const { datosMensualesBarrasApiladas, getDatosMensualesBarrasApiladas } =
    useInternacionesIniciadoAutorizadoBarraApilada({
      mensualList,
      mensualDate,
    });

  useEffect(() => {
    if (mensualList?.length > 0 && mensualDate) {
      getDatosMensualesBarrasApiladas();
    }
  }, [mensualList, mensualDate]);

  return (
    <Card sx={{ px: 3, py: 3, width: '100%', maxWidth: '800px', height: '300px' }}>
      <GraficoBar
        labels={datosMensualesBarrasApiladas?.labels || []}
        datasets={datosMensualesBarrasApiladas?.datasets || []}
        options={{
          plugins: {
            title: {
              text: 'Estado diario de autorizaciones',
              display: true,
            },
            legend: { position: 'bottom' },
          },
        }}
      />
    </Card>
  );
};
